/**
 * Smart polling helpers — pause when tab is hidden, avoid background hammering.
 */

export const POLL_INTERVALS = {
  /** Badge counts (notifications, messages) */
  BADGE: 60 * 1000,
  /** Admin online-status lists */
  PRESENCE: 30 * 1000,
  /** Active chat fallback when websocket unavailable */
  CHAT_FALLBACK: 15 * 1000,
  /** Conversation message thread */
  CHAT_MESSAGES: 20 * 1000,
};

/** Returns false when the document is hidden so React Query skips the poll tick. */
export const smartRefetchInterval = (ms) => () => {
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
    return false;
  }
  return ms;
};

export const smartQueryDefaults = {
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: false,
};
